angular.module('shared')
.service('keepAlive', function ($timeout,$http,BASE_PATH,$log) {
    var keepAlive=function(){
        $http.get(BASE_PATH.API_URL+'keepAlive').catch($log.error);
        $timeout(keepAlive, 1*60*1000);
    };
    keepAlive();
    return {};
});
